import { httpCall } from "@common/util";
import AppConstants from "@config/appConstants";
import { buildParams, getEndpointUrl } from "@utils/paramBuilder";

export const fetchUsersList = (params) => {
  const url = getEndpointUrl("usersList", false);
  const mappedParams = buildParams("usersList", params || {});
  const queryString = Object.keys(mappedParams).length
    ? "?" + new URLSearchParams(mappedParams).toString()
    : "";

  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: url + queryString,
  });
};

export const fetchUsersByIds = (userIds = []) => {
  const ids = userIds.filter((id) => id != null);
  if (ids.length === 0) return Promise.resolve({ users: [] });

  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: getEndpointUrl("usersList", false),
    data: { user_id: ids, page_number: 1, page_size: ids.length },
  });
};

export const fetchUser = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("user", false)}/${userId}/profile`,
  });
}

export const blockUser = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.PUT,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("blockUser", false)}/${userId}`,
  });
};

export const searchUsers = (params) => {
  const url = getEndpointUrl("searchUsers", false);
  const { search_columns, search_string, ...rest } = params || {};
  const queryParams = {};
  if (search_columns) queryParams.search_columns = search_columns;
  if (search_string) queryParams.search_string = search_string;
  Object.assign(queryParams, rest);
  const queryString = Object.keys(queryParams).length
    ? "?" + new URLSearchParams(queryParams).toString()
    : "";
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: url + queryString,
  });
};

export const unblockUser = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.PUT,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("unblockUser", false)}/${userId}`,
  });
};

export const resetUserPassword = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.PUT,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("resetPassword", false)}?id=${userId}`,
  });
};

export const createUser = (userData) => {
  return httpCall({
    method: AppConstants.httpMethod.POST,
    headers: { "Content-Type": "application/json" },
    url: getEndpointUrl("createUser", false),
    data: userData,
  }, true);
};

export const updateUser = (payload) => {
  return httpCall({
    method: AppConstants.httpMethod.PUT,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("createUser", false)}/${payload.user.id}`,
    data: payload,
  }, true);
};

export const fetchUserDetail = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("userDetail", false)}/${userId}/detail`
  });
};

export const fetchUserPermissions = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("userPermissions", false)}/${userId}`,
  });
};

export const checkUsernameAvailability = ({ username }) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("checkUsernameAvailability", false)}/${username}`,
  });
};

export const fetchUserTemplates = () => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("userTemplates", false)}?detailed=true`,
  });
};

export const fetchCurrentUser = () => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: getEndpointUrl("currentUser", false),
  });
};

export const fetchTimezoneList = () => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: "/1.0/timezone/list",
  });
};

export const fetchWorkloadWorkkards = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("workloadWorkkards")}/${userId}`,
  });
};

export const fetchWorkloadActivities = ({ userId }) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `${getEndpointUrl("workloadActivities")}/${userId}`,
  });
};

export const transferWorkload = (payload) => {
  return httpCall({
    method: AppConstants.httpMethod.POST,
    headers: { "Content-Type": "application/json" },
    url: getEndpointUrl("workloadTransfer"),
    data: payload,
  });
};